import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './locales/zh-CN';
import en from './locales/en';

Vue.use(VueI18n);

/**
 * 多语言实例：仅保留中文与英文，语言选择保存在 localStorage，刷新页面后继续沿用。
 */
const storedLocale = localStorage.getItem('language');
const locale = storedLocale === 'zh-CN' || storedLocale === 'en' ? storedLocale : 'en';

if (storedLocale !== locale) {
  localStorage.setItem('language', locale);
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: {
    'zh-CN': zhCN,
    en,
  },
});

export default i18n;
